import {
  List,
  Datagrid,
  TextField,
  EditButton,
  usePermissions,
  FunctionField,
  TextInput,
} from "react-admin";

import { Chip, Tooltip } from "@mui/material";

const CategoryList = () => {
  const { permissions = [] } = usePermissions();  //

  const categoryFilters = [
    <TextInput
      label="Search Category / Subcategory"
      source="q"
      alwaysOn
    />,
  ];

  return (
    <List
      title="Assessment Categories"
      filters={categoryFilters}
      sx={{
        "& .RaDatagrid-row": {
          height: 80,
          borderRadius: "12px",
        },
      }}
    >
      <Datagrid
        sx={{
          "& .RaDatagrid-row": {
            borderRadius: "12px",
            mb: 1,
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            verticalAlign: "top",
          },
        }}
      >
        {/* ID */}
        <TextField source="id" />

        {/* CATEGORY */}
        <FunctionField
          label="Category"
          render={(record) => (
            <Chip
              label={record.category_name || "-"}
              size="small"
              sx={{
                maxWidth: "180px",
                height: "auto",

                "& .MuiChip-label": {
                  display: "block",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  lineHeight: 1.4,
                  padding: "6px 8px",
                },
              }}
            />
          )}
        />
        {/* SUBCATEGORY */}
        <FunctionField
            label="Subcategory"
            render={(record) => (
              <Chip
                label={record.subcategory_name || "-"}
                size="small"
                sx={{
                  maxWidth: "180px",
                  height: "auto",

                  "& .MuiChip-label": {
                    display: "block",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: 1.4,
                    padding: "6px 8px",
                  },
                }}
              />
            )}
          />

        {/* DESCRIPTION (with tooltip for long text) */}
        <FunctionField
          label="Description"
          render={(record) => (
            <Tooltip title={record.description || ""}>
              <Chip
                label={
                  record.description?.length > 30
                    ? record.description.slice(0, 30) + "..."
                    : record.description || "-"
                }
                size="small"
              />
            </Tooltip>
          )}
        />

        {/* EDIT BUTTON */}
        {(permissions.includes("assessments.edit") ||
          permissions.includes("assessments.*") ||
          permissions.includes("*")) && <EditButton />}
      </Datagrid>
    </List>
  );
};

export default CategoryList;